import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SHARED_ROUTES } from "../../config/routes";
import { useSelector, useDispatch } from "react-redux";
import { Flex, Text, Heading } from "@chakra-ui/react";
import { logout, reset } from "../../features/auth/authSlice";
import Spinner from "../../components/FormElements/Spinner";
import Button from "../../components/FormElements/Button";
import StudentList from "../components/StudentList";
import { getStudents } from "../../features/students/studentSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { Link } from "react-router-dom";

export const StudentHomePage = () => {
  //initialise dispatch
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { student, isLoading, isSuccess } = useSelector(
    (state) => state.student
  );
  const students = student; //TODO: Fix Redux state naming

  useEffect(() => {
    dispatch(getStudents())
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          return response;
        } else {
          throw response.payload;
        }
      })
      .then(unwrapResult)
      .catch((error) => {
        if (
          error.status === 500 ||
          error.status === 401 ||
          error.status === 403
        ) {
          window.alert("Authorisation error: please sign in again.");
          //reset user
          dispatch(logout()).then(() => {
            dispatch(reset());
            navigate("/");
          });
        } else {
          navigate(SHARED_ROUTES.home); //refresh page
          window.alert("Error: failed to load students");
        }
      });
  }, []);

  if (isLoading) return <Spinner />;

  return students && students.length === 0 && isSuccess ? (
    <Flex direction="column" alignItems="center" mt="5em" mb="5em" fontWeight="semibold">
      <Heading as="h2" size="lg" textAlign="center" mb="1em" mt="0.7em">
        Welcome to the Arup Transition Year Booking System
      </Heading>
      <Text>
        No students registered yet.
      </Text>
      <Text>Would you like to register a student?</Text>
      <Link to={SHARED_ROUTES.createStudent}>
        <Button as="span" colorScheme="red">
          Add Student
        </Button>
      </Link>
    </Flex>
  ) : (
    <Flex direction="column" justifyContent="center">
      <Heading as="h2" size="lg" textAlign="center" mb="1em" mt="0.7em">
        Welcome to the Arup Transition Year Booking System
      </Heading>
      <StudentList students={students} shouldOmitSource />
    </Flex>
  );
};
